export enum ResponsiveMode {
    vertical = 'vertical',
    horizontal = 'horizontal'
}